import { Injectable } from '@angular/core';
import { Moment } from 'moment-timezone';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {AuditEntry} from '../models/AuditEntry';
import {HttpParams} from '@angular/common/http';
import {HttpService} from './http.service';
import {map} from 'rxjs/operators';

@Injectable()
export class AuditService {

    constructor(
        private httpService: HttpService
    ) { }

    getAuditTrailForUser(userId: number, timeStart: Moment, timeEnd: Moment): Observable<Array<AuditEntry>> {
        /*
        if (!skipCache && this.cacheService.hasItem('user-audit-trail', userId)) {

            return Observable.of(this.cacheService.getItem('user-audit-trail', userId));

        } else {
            */
        let params: HttpParams = new HttpParams();
        params = params.set('timeStart', timeStart.format());
        params = params.set('timeEnd', timeEnd.format());

        return this.httpService.get<Array<AuditEntry>>(
            environment.apiV1BaseUrl + '/accounts/user-audit-trails/' + userId.toString(),
        { params: params }
        ).pipe(
            map(this.fixAuditEntriesWithUtf16)
        );
    // }
    }

    getAuditTrailForResource(resourceType: string, resourceId: number, timeStart: Moment, timeEnd: Moment) {

        let params = new HttpParams();
        params = params.set('timeStart', timeStart.format());
        params = params.set('timeEnd', timeEnd.format());

        return this.httpService.get<Array<AuditEntry>>(
            environment.apiV1BaseUrl + '/accounts/resource-audit-trails/' + resourceType + '/' + resourceId.toString(),
            { params: params }
        ).pipe(
            map(this.fixAuditEntriesWithUtf16)
        );
    }


    getMyAuditTrail(timeStart: Moment, timeEnd: Moment) {

        let params = new HttpParams();
        params = params.set('timeStart', timeStart.format());
        params = params.set('timeEnd', timeEnd.format());

        return this.httpService.get<Array<AuditEntry>>(
            environment.apiV1BaseUrl + '/accounts/my-audit-trails',
            { params: params }
        ).pipe(
            map(this.fixAuditEntriesWithUtf16)
        );
    }

    fixAuditEntriesWithUtf16(auditEntries: Array<AuditEntry>): Array<AuditEntry> {
        for (let audit of auditEntries) {

            let data = audit.resource ? audit.resource.data : null;

            if (data) {
                let dataIsUtf16 = true;

                // Check first 1000 chars or length of data if less
                const limit = Math.min(1000, data.length);

                for (let i = 1; i < limit; i += 2) {
                    if (data[i].charCodeAt(0) != 0) {
                        dataIsUtf16 = false;
                        break;
                    }
                }

                if (dataIsUtf16) {
                    let newStr = '';
                    for (let i = 0; i < data.length; i += 2) {
                        newStr += data[i];
                    }
                    audit.resource.data = newStr;
                }
            }
        }

        return auditEntries;
    }
}
